import { gettext } from '@eventbrite/i18n';
import { ArrowRightIcon, Button, Typography } from '@eventbrite/marmalade';
import { logEvent } from '@eventbrite/statsig';
import React from 'react';
import './NightlifeTouchpoint.scss';

export const STATSIG_CITY_BROWSE_CLICK_NIGHTLIFE_TOUCHPOINT =
    'City Browse - All - Click - Nightlife Touchpoint';

export const ELIGIBLE_CITIES = {
    '85922583': 'SAN_FRANCISCO',
    '85923517': 'LOS_ANGELES',
    '85940195': 'CHICAGO',
    '85977539': 'NEW_YORK',
    '101750367': 'LONDON',
};

export const NightlifeTouchpoint = (props: {
    currentPlace: string;
    slug: string;
    placeId: string;
}) => {
    const { currentPlace, slug, placeId } = props;

    const isCityEligible =
        placeId != null &&
        new Set(Object.keys(ELIGIBLE_CITIES)).has(placeId) &&
        slug != null;

    const ctaLink =
        slug != null &&
        `/b/${slug}/nightlife/?utm_source=citybrowse_nightlife_touchpoint_click`;

    const touchpointTitle = gettext('Live your best ');
    const touchpointSubTitle = gettext('nightlife in %(currentPlace)s ', {
        currentPlace,
    });

    if (!isCityEligible) {
        return null;
    }

    const handleOnClick = () => {
        logEvent(STATSIG_CITY_BROWSE_CLICK_NIGHTLIFE_TOUCHPOINT);
    };

    return (
        <div className="nightlife-touchpoint">
            <div className="nightlife-touchpoint-container">
                <div
                    className="nightlife-touchpoint-title-subtitle-container"
                    data-testid="nightlife-touchpoint-title-subtitle"
                >
                    <Typography as="h2" className="nightlife-touchpoint-title">
                        {touchpointTitle}
                    </Typography>
                    <Typography
                        as="h2"
                        className="nightlife-touchpoint-subtitle"
                    >
                        {touchpointSubTitle}
                    </Typography>
                </div>
                <a
                    href={ctaLink || ''}
                    data-heap-id="citybrowse_nightlife_touchpoint_click"
                >
                    <Button
                        className="nightlife-touchpoint-button"
                        onClick={handleOnClick}
                    >
                        <span className="nightlife-touchpoint-button__text">
                            {gettext('Explore')}
                        </span>
                        <ArrowRightIcon className="nightlife-touchpoint-arrowRight" />
                    </Button>
                </a>
            </div>
        </div>
    );
};

export default NightlifeTouchpoint;
